module.exports = __webpack_public_path__ + "static/media/food-court-chairs1.d5314250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/structures/food-court-chairs1.png
// module id = 157
// module chunks = 0